import { Localization } from "../../../../../../OW.Remoting/Remoting/Localization";
import { Control } from "../../../../../UI.BaseControls/Control";
import { DropDownMenuItem } from "../../../../../UI.Controls/DropDownMenu/DropDownMenuItem";
import { createElement, registerCustomElement } from "../../../../../UI.ElementarControls/Utils/CustomElementUtils";

export class DropDownMenuItemWithButton extends DropDownMenuItem {
    private _groupTitleLocKey: string;

    private _btnParent: HTMLElement;
    private _groupTitle: HTMLElement;
    private _floatMenu: boolean = false;
    private _btnFloatMenu: HTMLElement;
    private _bntAction: (item: DropDownMenuItemWithButton) => void;

    public get floatMenu(): boolean {
        return this._floatMenu;
    }
    public set floatMenu(val: boolean) {
        this._floatMenu = val;
        this._btnParent.classList.add("more-button", "icon", "ui-more-vertical");
    }

    public get isEnabled(): boolean {
        return !this.classList.contains("disabled");
    }

    public set isEnabled(val: boolean) {
        this.classList.toggle("disabled", !val);
    }

    public override set locKey(v: string) {
        this._locKey = v;
        if (this._locKey) {
            Localization.getTextPromise(this._locKey).then((locItem) => {
                this._captionElement.textContent = locItem;
            });
        }
    }

    public set groupLocKey(v: string) {
        this._groupTitleLocKey = v;

        if (this._groupTitleLocKey) {
            this._groupTitle.classList.remove("Hidden");
            Localization.getTextPromise(this._groupTitleLocKey).then((locItem) => {
                this._captionElement.textContent = locItem;
            });
        } else {
            this._groupTitle.classList.add("Hidden");
        }
    }

    public get groupLocKey(): string {
        return this._groupTitleLocKey;
    }

    public get buttons(): HTMLButtonElement[] {
        return Array.from(this._btnParent.querySelectorAll(":scope > button.MenuItemButton")) as HTMLButtonElement[];
    }

    /**
     * Stav/nastavení skrytí bloku s tlačítky
     */
    public get hideButtons(): boolean {
        return (this._btnParent) ? this._btnParent.classList.contains("hidden") : false;
    }

    public set hideButtons(value: boolean) {
        if (this._btnParent)
            this._btnParent.classList.toggle("hidden", value);
    }

    protected override _constructor(): void {
        super._constructor();

        //this.Priority = ;
        //this.locKey = locKey;
        this.visible = true;
        //if (subMenu) this.Submenu = subMenu;
    }

    protected override _createElement(): void {
        this.classList.add("DropDownMenuItem", "DropDownMenuItemWithButton");
        const leftContainer = createElement({ type: "div", classes: "left-container" });
        //const container = createElement({ type: "div", classes: "container" });
        const flexContainer = createElement({ type: "div", classes: "flex-container Text" });
        this._btnParent = createElement({ type: "div", classes: "btn-bar" });
        this._groupTitle = createElement({ type: "div", classes: "group-title hidden" });
        this._btnFloatMenu = createElement({ type: "div", classes: "float-menu" });

        this._createCaptionElement();
        this._createIconElement();

        flexContainer.appendChild(this._captionElement);
        flexContainer.appendChild(this._btnParent);
        flexContainer.appendChild(this._btnFloatMenu);

        //flexContainer.appendChild(container);
        leftContainer.appendChild(this._groupTitle);
        leftContainer.appendChild(flexContainer);

        this.appendChild(this._iconElement);
        this.appendChild(leftContainer);
    }

    protected override _createCaptionElement(): void {
        this._captionElement = document.createElement("div");
        this._captionElement.classList.add("Caption");
    }

    public addButton(item: IDropDownMenuButton): void {
        const btn = createElement({ type: "button", classes: ["icon", "MenuItemButton", ...item.icon], css: { order: item.order || 20 } });
        Control.registerEventListener(`_button_menuItemWithButton_${this._innerId}`, btn, "click", (e: MouseEvent) => { //`
            e.stopPropagation();
            item.action(this);
        });
        this._bntAction = item.action;
        Localization.addLocDescData(btn, item.locKey, "title");
        if (this._floatMenu) this._btnFloatMenu.appendChild(btn);
        else this._btnParent.appendChild(btn);
    }

    public addButtons(items: IDropDownMenuButton[]): void {
        for (const item of items) {
            this.addButton(item);
        }
    }

    public removeButtons(): void {
        this._btnParent.innerHTML = "";
        this._btnFloatMenu.innerHTML = "";
        Control.unregisterEventListener(`_button_menuItemWithButton_${this._innerId}`); //`
    }

    protected override _setListener(): void {
        super._setListener();

        Control.registerEventListener(`_button_menuItemWithButton_${this._innerId}`, this._btnParent, "click", (e: MouseEvent) => {
            e.stopPropagation();
            this._bntAction(this);
        });
    }

    public override dispose(): void {
        super.dispose();
        Control.unregisterEventListener(`_button_menuItemWithButton_${this._innerId}`); //`
    }
}

export interface IDropDownMenuButton {
    icon: string[];
    locKey: string;
    action: (item?: DropDownMenuItemWithButton) => void;
    order?: number;
    displayOn?: DropDownMenuButtonDisplayOn;
}

export enum DropDownMenuButtonDisplayOn {
    always,
    hover,
}

registerCustomElement("tsc-DropDownMenuItemWithButton", DropDownMenuItemWithButton);
